<script lang="ts" setup>
import OmniDialog from "@/components/omni/OmniDialog.vue";
import { computed } from "vue";
import type { TripUpdate } from "@/api/trips/dto/update";
import { DialogSize } from "@/constants/dialog";
import ViewUpdate from "@/views/trips/components/ViewUpdate.vue";
import type { CheckCallType } from "@/api/trips/dto/check-call";

const showDialog = defineModel<boolean>({ default: false });

const props = defineProps<{
  update: TripUpdate;
  checkCallType: CheckCallType;
}>();

const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const title = computed(() => {
  return `Update for Travel order#${props.update.travelOrderId}`;
});

function close() {
  emits("update:modelValue", false);
}
</script>

<template>
  <omni-dialog
    v-model="showDialog"
    :size="DialogSize.xlarge"
    :title="title"
    secondary-action-label="Close"
    @secondary-action:click="close"
  >
    <view-update :check-call-type="checkCallType" :update="props.update" should-transform-files />
  </omni-dialog>
</template>
:
